import type { SVGProps } from 'react';
import Success from '../../../assets/success.svg';

const SuccessIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => <Success {...props} />;

export default SuccessIcon;
